var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5986 11.3566L15.5 2.42705L18.4014 11.3566C18.5553 11.8304 18.9969 12.1512 19.4951 12.1512H28.8842L21.2883 17.67C20.8852 17.9628 20.7165 18.4819 20.8705 18.9557L23.7719 27.8853L16.176 22.3665C15.7729 22.0737 15.2271 22.0737 14.824 22.3665L7.22813 27.8853L10.1295 18.9557C10.2835 18.4819 10.1148 17.9628 9.71175 17.67L2.11583 12.1512H11.5049C12.0031 12.1512 12.4447 11.8304 12.5986 11.3566ZM6.35666 28.5184C6.35692 28.5182 6.35717 28.518 6.35743 28.5179L6.35666 28.5184Z",
    stroke: "#0C99FF",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.cf78fc5b684831a82db3583f442c94bd.svg";
export { ForwardRef as ReactComponent };